import currencyLib from "currency.js";
import { useRouter } from "next/router";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import { setCartDrawerState } from "../../../services/redux/slices/drawers";
import { PagesEnum } from "../../../utils/enums";
import { getPageLink } from "../../../utils/help/navigation/navigation";
import { ItemList } from "../../screens/S-Cart/ItemList/ItemListComponent";
import { CloseIcon } from "../Icons/Icons";
import { PLink } from "../PLink";
import styles from "./CartDrawer.module.scss";

export const CartDrawer = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { t } = useTranslationI18();
  const franchiseConfig = useAppSelector(
    (state) => state.config.selectedFranchise?.franchiseConfig
  );
  const drawerState = useAppSelector(
    (store) => store.drawersSlice.cartDrawerIsOpen
  );
  const toggleDrawer = (open: boolean) => {
    dispatch(setCartDrawerState(open));
  };
  const currency = useAppSelector((state) => state.config.currency);
  const subTotal = useAppSelector((state) => state.cartLoyaltyV2Reducer).cart
    .subTotalPrice;
  const hidePrice = franchiseConfig?.forFeatureShowcase ?? false;

  const myOrder = t("cart:cart-order");
  const subtotalTranslation = t("common:global-subtotal");
  const goToCart = t("common:go-to-cart");

  return (
    <div
      className={`${styles.drawer_wrapper} ${
        drawerState && styles.drawer_active
      }`}
    >
      <div
        onClick={() => toggleDrawer(false)}
        className={`${styles.drawer_background} ${
          drawerState && styles.active_background
        }`}
      ></div>
      <div className={`${styles.cart_drawer}`}>
        <div className={styles.cart_drawer__inner}>
          <div className={styles.cart_drawer__inner__header}>
            <h2 className="main_title">{myOrder}</h2>
            <span
              onClick={() => toggleDrawer(false)}
              className={"sidebar_close " + styles.close}
            >
              <CloseIcon />
            </span>
          </div>
          <div className={styles.item_list}>
            <ItemList />
          </div>
        </div>
        <div className={styles.cart_drawer__inner__footer}>
          {!hidePrice && (
            <div className={styles.sub_total}>
              <span className={styles.sub_total_title}>
                {subtotalTranslation}
              </span>
              <span className={styles.sub_total_price}>
                {currency}
                {currencyLib(subTotal).value}
              </span>
            </div>
          )}
          <PLink
            keyString={"cart"}
            link={getPageLink(router, PagesEnum.Cart)}
            passHref
          >
            <a
              data-testid={"go-to-cart"}
              className={styles.drawer_cart_button}
              onClick={() => toggleDrawer(false)}
            >
              {goToCart}
            </a>
          </PLink>
        </div>
      </div>
    </div>
  );
};
